
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.26 11.793c-.896 0-1.626-.699-1.626-1.557V7.972C21.634 6.333 20.24 5 18.528 5h-.789c-.408 0-.739.317-.739.708 0 .39.331.707.74.707h.788c.897 0 1.627.698 1.627 1.557v2.264c0 .906.426 1.718 1.096 2.264a2.916 2.916 0 00-1.096 2.264v2.264c0 .859-.73 1.557-1.627 1.557h-.789c-.408 0-.739.317-.739.707 0 .391.331.708.74.708h.788c1.713 0 3.106-1.333 3.106-2.972v-2.264c0-.858.73-1.556 1.627-1.556.408 0 .739-.317.739-.708 0-.39-.331-.707-.74-.707zM3.845 10.236V7.972c0-.859.73-1.557 1.627-1.557h.789c.408 0 .739-.317.739-.707C7 5.317 6.669 5 6.26 5h-.788C3.759 5 2.366 6.333 2.366 7.972v2.264c0 .858-.73 1.556-1.627 1.556-.408 0-.739.317-.739.708 0 .39.331.707.74.707.896 0 1.626.699 1.626 1.557v2.264C2.366 18.667 3.76 20 5.472 20h.789c.408 0 .739-.317.739-.707 0-.391-.331-.708-.74-.708h-.788c-.897 0-1.627-.698-1.627-1.557v-2.264c0-.906-.426-1.718-1.096-2.264a2.916 2.916 0 001.096-2.264z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M15.757 16.059a.707.707 0 00-.704.704.707.707 0 00.704.705.706.706 0 000-1.41zM12 16.059a.707.707 0 00-.705.704.705.705 0 10.705-.704zM8.243 16.059a.705.705 0 000 1.409.707.707 0 00.704-.705.707.707 0 00-.704-.704z","fill":"#E2E4EC"}})])
          )
        }
      }
    